import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope } from '../envelope.js';
import { tokenRefreshSchema } from '../common/schemas.js';
import { authUserSchema } from './auth.contract.js';
const c = initContract();
export const loginMethodSchema = z.object({
    id: z.string(),
    provider: z.string(),
    label: z.string(),
    isPrimary: z.boolean(),
    verifiedAt: z.string().nullable(),
    /** Helix / YouTube Data API 수집용 refresh 보관 여부. */
    hasApiCapability: z.boolean(),
});
export const userUsersContract = c.router({
    getProfile: {
        method: 'GET',
        path: '/user/profile',
        responses: {
            200: requiredPayloadEnvelope(z.object({ user: authUserSchema })),
            ...commonErrorResponses,
        },
    },
    updateProfile: {
        method: 'PATCH',
        path: '/user/profile',
        body: z.object({
            name: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({ user: authUserSchema })),
            ...commonErrorResponses,
        },
    },
    changePassword: {
        method: 'PATCH',
        path: '/user/change-password',
        body: z.object({
            currentPassword: z.string().optional(),
            newPassword: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(tokenRefreshSchema),
            ...commonErrorResponses,
        },
    },
    listLoginMethods: {
        method: 'GET',
        path: '/user/login-methods',
        responses: {
            200: requiredPayloadEnvelope(z.object({ loginMethods: z.array(loginMethodSchema) })),
            ...commonErrorResponses,
        },
    },
    disconnectLoginMethod: {
        method: 'POST',
        path: '/user/login-methods/:id/disconnect',
        pathParams: z.object({ id: z.string() }),
        body: z.null().optional(),
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=users.contract.js.map